/**
 * Styled Components - Created by jorge on 01/08/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  font-family: Avenir;
  background-color: #fff;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  justify-content: center;
  color: black;
  text-align: center;
  padding: 0 28px;
  img {
    max-width: 96px;
    width: 100%;
  }
  #title, #subtitle {
    font-weight: 600;
  }
  #title {
    font-size: 28px;
    margin-block: 40px;
  }
  #subtitle {
    font-size: 16px;
    margin-bottom: 12px;
  }
  #desc {
    font-size: 20px;
  }
  #note {
    font-size: 14px;
    margin-top: 40px;
    color: #625F5F;
  }
  #actions {
    position: fixed;
    bottom: 50px;
    max-width: 700px;
    width: 100%;
    text-align: right;
    padding-inline: 28px;
  }
  #btn {
    padding: 12px 42px;
    border-radius: 25px;
    color: white;
    background: black;
    width: fit-content;
    justify-self: flex-end;
    font-weight: 600;
    :hover {
      cursor: pointer;
      background: white;
      color: black;
      outline: 1px solid black;
    }
    @media (max-width: 698px) {
      width: 100%;
      text-align: center;
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ConfirmMeasure/styledComponents.tsx